import moment from 'moment';
import decoded from 'jwt-decode';
import { isValidNationalNumber } from './validate';
import { genderList } from './constants';

//──── National number read and get data ─────────────────────────────────────────────────
export const prepareNationalNumber = nationalNumber => {
  if (nationalNumber) {
    return `${nationalNumber.slice(0, 6)}-${nationalNumber.slice(6, 9)}.${nationalNumber.slice(
      9,
      11
    )}`;
  }
  return '';
};

export const getGenderFromNN = NN => {
  if (NN && isValidNationalNumber(NN)) {
    const _digitalGender = parseInt(NN.slice(6, 9), 10);
    if (_digitalGender % 2) {
      return genderList[0].value;
    } else {
      return genderList[1].value;
    }
  } else {
    return NN;
  }
};

export const getUserBirthDate = NN => {
  if (NN && isValidNationalNumber(NN)) {
    const currentYear = moment().format('YYYY');

    const userYear = moment(NN.slice(0, 6), 'YYMMDD').format('YYYY');
    return moment
      .utc()
      .set('year', currentYear > userYear ? userYear : String(userYear).replace('20', '19'))
      .set('month', Number(NN.slice(2, 4)) - 1)
      .set('date', NN.slice(4, 6))
      .startOf('day')
      .toISOString();
  }
  return null;
};

//──── Token ─────────────────────────────────────────────────────────────────────────────
export const normalizeToken = token => {
  const decodedToken = decoded(token);

  return {
    aud: decodedToken.aud,
    exp: decodedToken.exp,
    role: decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
    serialNumber:
      decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/serialnumber'],
    emailAddress:
      decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
    nameIdentifier:
      decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
    iss: decodedToken.iss,
    nbf: decodedToken.nbf
  };
};

const ua = window.navigator.userAgent;
export const isIE = /MSIE|Trident/.test(ua);

export const campusesName = backEndName => {
  if (backEndName && typeof backEndName === 'string') {
    return backEndName.replace('Private', '');
  }
  return backEndName;
};

export const getLongDate = (i18n, time) => {
  let momentTime = moment(time) || moment();
  let day =
    momentTime
      .format('dddd')
      .charAt(0)
      .toUpperCase() + momentTime.format('dddd').slice(1);
  let month =
    momentTime
      .format('MMMM')
      .charAt(0)
      .toUpperCase() + momentTime.format('MMMM').slice(1);
  let date = momentTime.format('DD');
  return `${day} ${moment.locale() === 'nl' ? date : month} ${
    moment.locale() === 'nl' ? month : date
  }`;
};

//──── State helpers ─────────────────────────────────────────────────────────────────────
export const createDeepCopy = object => JSON.parse(JSON.stringify(object));

export const updateObject = (obj, data) => {
  const initObj = createDeepCopy(obj);

  function isObj(value) {
    return value !== null && typeof value === 'object' && !value.length;
  }

  function update(objectClone, updateData) {
    for (let updateKey in updateData) {
      if (objectClone[updateKey]) {
        if (isObj(updateData[updateKey])) {
          update(objectClone[updateKey], updateData[updateKey]);
        } else {
          objectClone[updateKey] = updateData[updateKey];
        }
      } else {
        objectClone[updateKey] = updateData[updateKey];
      }
    }
  }
  update(initObj, data);

  return initObj;
};

// Sorting
export const sortArrayFromTag = (arr, target) => {
  if (Array.isArray(arr) && target && arr[0] && arr[0][target]) {
    return arr.sort((a, b) => a[target].localeCompare(b[target]));
  }
};

// open URL Schemes
export const openUrlSchemes = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    const { href, origin } = window.location;
    var route = href.replace(origin, '');
    if ('standalone' in window.navigator) {
      // IOS
      window.location.href = 'umbiapp:/' + route;
    } else {
      // Android
      window.location.href = 'umbiapp:/' + route + ';scheme=umbiapp;end;';
      // var ifrm = document.createElement('iframe');
      // ifrm.style.width = 0;
      // ifrm.style.height = 0;
      // ifrm.src = 'umbiapp:/' + route;
      // document.body.appendChild(ifrm);
    }
  }
};

// Appointments
export const getAppointmentViewState = (obj = {}) => {
  return obj.appointment && obj.appointment.viewModel && obj.appointment.viewModel.state;
};
